class ImageTabs extends HTMLElement {
  constructor() {
    super();

    /** @type {NodeListOf<HTMLDivElement>} */
    this.imageTabsItems = this.querySelectorAll('.js-image-tab-item');
    /** @type {NodeListOf<HTMLDivElement>} */
    this.imageTabsContents = this.querySelectorAll('.js-image-tab-content');

    this.onImageTabItemClick = this.onImageTabItemClick.bind(this);
  }

  connectedCallback() {
    this.imageTabsItems.forEach((item) => {
      item.addEventListener('click', this.onImageTabItemClick);
    });
  }

  disconnectedCallback() {
    this.imageTabsItems.forEach((item) => {
      item.removeEventListener('click', this.onImageTabItemClick);
    });
  }

  /**
   * @param {PointerEvent} event
   */
  onImageTabItemClick(event) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) return;

    this.imageTabsItems.forEach((item, index) => {
      item.classList.toggle('image-tab__image-item--active', item === target);
      this.imageTabsContents[index]?.classList.toggle('image-tab-content--active', item === target);
    });
  }
}

customElements.define('image-tabs', ImageTabs);
